import { IconButton, mergeStyles } from '@fluentui/react';
import { FC } from 'react';
import { IUpdateUserProps } from '../resourceHelpers';
import { useToggle } from '../../../../../hooks/useToggle';
import { UpdateUserModal } from './UpdateUserModal';

const iconButtonStyle = mergeStyles({
    margin: '0 auto',
});

export const UpdateUser: FC<IUpdateUserProps> = ({ user, setUser }) => {
    const [isModalOpened, toggleModal] = useToggle(false);

    return (
        <>
            <IconButton iconProps={{ iconName: 'Edit' }} title="Edit user" ariaLabel="Edit user" onClick={() => toggleModal()} className={iconButtonStyle} />
            <UpdateUserModal isOpen={isModalOpened} onDismiss={() => toggleModal()} user={user} setUser={setUser} />
        </>
    );
};
